import api from "./init";
import { headers } from "./apiHelper";

export const getCategories = (resolveHandler) => {
  api
    .get("/categories", {
      headers,
    })
    .then((res) => {
      resolveHandler(res.data);
    });
};
